import React, { useEffect, useState } from "react";
import contract from "../assets/undraw_cancel_re_pkdm.svg";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Box,
    Typography,
    useTheme,
    TextField,
} from "@mui/material";
import { updateContract } from "state/apis";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { add } from "dayjs";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Termination = ({ open, onClose, onSubmit, editData, editMode }) => {
    const theme = useTheme();
    const [terminatedDate, setTerminatedDate] = useState("");
    const [isShow, setIsShow] = useState(false);
    const [balance, setBalance] = useState(0);
    const navigate = useNavigate();

    const handleChangeDate = (date) => {
        const formattedDate = date.format("YYYY-MM-DD");
        setTerminatedDate(formattedDate);

        const rentPerDay = parseFloat((editData?.yearRent / 365).toFixed(4));
        const paidUntilDate = moment(editData?.paidUntilDate, "DD/MM/YYYY");
        const daysDifference = moment(formattedDate).diff(paidUntilDate, "days");
        const remainingBalance = rentPerDay * daysDifference;

        setBalance(remainingBalance);
        setIsShow(true);
    };

    const handleSubmit = async (dispute = false) => {
        if (!terminatedDate) {
            return toast.error("Please select terminated date");
        }
        const response = await updateContract(editData.id, {
            propertyId: editData.propertyId,
            unitId: editData.unitId,
            tenantId: editData.tenantId,
            yearRent: editData.yearRent,
            totalYearsOfStay: editData.totalYearsOfStay,
            contractFrom: editData.contractFrom,
            contractTo: editData.contractTo,
            remarks: editData.remarks,
            deposit: editData.deposit,
            totalYearsOfStay: editData.totalYearsOfStay || 0,
            totalReceivedRent: editData?.totalReceivedRent || 0,
            closed: true,
            terminated: true,
            terminatedDate: moment(terminatedDate).format("YYYY-MM-DD"),
            isRentDispute: dispute,
            rentDisputeBalance: dispute ? balance : "",
        });

        onSubmit();
        onClose();
        if (dispute) {
            navigate("/rent dispute");
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth={"sm"}>
            <DialogTitle sx={{ textAlign: "center", fontWeight: "900", mb: "2px" }}>
                Confirmation
            </DialogTitle>
            <DialogContent>
                {/* <Grid container spacing={3} p={"5px"}>
                    <Grid item xs={12} container direction="column" alignItems="center">
                        <Box
                            component="img"
                            alt="select"
                            src={contract}
                            height="200px"
                            width="200px"
                            sx={{ objectFit: "cover" }}
                        />
                        <Typography variant="body1" mt={2} textAlign={"center"}>
                            Are You Sure Want To Cancel This Contract ?
                        </Typography>
                    </Grid>
                </Grid> */}
                <Grid container spacing={2} my={"8px"}>
                    <Grid item xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} color="primary">
                            <DatePicker
                                fullWidth
                                label="Select date"
                                name="date"
                                onChange={handleChangeDate}
                                value={terminatedDate ? dayjs(terminatedDate) : null}
                                format="DD/MM/YYYY"
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "secondary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "secondary.main",
                                        },
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                    {isShow && (
                        <>
                            <Grid item xs={12}>
                                <TextField
                                    color="primary"
                                    fullWidth
                                    label="Rent Balance"
                                    name="rentBalance"
                                    value={balance}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    color="primary"
                                    fullWidth
                                    label="Deposit"
                                    name="deposit"
                                    value={editData?.deposit}
                                    disabled
                                />
                            </Grid>
                        </>
                    )}
                </Grid>

                <DialogActions sx={{ justifyContent: "center" }}>
                    <Button
                        variant="contained"
                        onClick={() => handleSubmit(true)}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        Rent Disputed
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => handleSubmit(false)}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        Close The Contract
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default Termination;
